import React from 'react';
import { useReveal, PageHero, SectionHead, PillLink, Photo, GetInvolved } from '../Components/shared';
import { PROGRAMS, SOLUTIONS, PROCESS } from '../data/site';

function Services() {
  const ref = useReveal();
  return (
    <main id="main" ref={ref}>
      <PageHero
        eyebrow="Services"
        title={['We teach it.', 'We build it.']}
        lead="Two tracks, one team: accessible IT training for young people, and software engineering solutions for organisations."
        photo="laptopIndoors"
      />

      <section className="section" id="training">
        <div className="wrap">
          <SectionHead kicker="Track 01 · Training" title="Programmes that open the digital world.">
            Accessible, affordable and hands-on, designed for underserved communities and delivered with mentorship.
          </SectionHead>
          <ol className="programs">
            {PROGRAMS.map((p, i) => (
              <li key={p.title} className="program" data-reveal style={{ '--d': i }}>
                <span className="numbered-n">{String(i + 1).padStart(2, '0')}</span>
                <h3 className="h3">{p.title}</h3>
                <p className="body">{p.body}</p>
              </li>
            ))}
            <li className="program program-cta" data-reveal style={{ '--d': 5 }}>
              <h3 className="h3">Ready to learn?</h3>
              <p className="body">Register your interest and we'll let you know when the next cohort opens.</p>
              <PillLink to="/joinUs">Join a cohort</PillLink>
            </li>
          </ol>
        </div>
      </section>

      <section className="section dark" id="solutions">
        <div className="wrap">
          <SectionHead kicker="Track 02 · Software solutions" title="Engineering, delivered by our team.">
            From a first website to a data platform, we design, build and support software that works for your people.
          </SectionHead>
          <ol className="numbered two">
            {SOLUTIONS.map((s, i) => (
              <li key={s.title} data-reveal style={{ '--d': i }}>
                <span className="numbered-n">{String(i + 1).padStart(2, '0')}</span>
                <div>
                  <h3 className="h3">{s.title}</h3>
                  <p className="body">{s.body}</p>
                </div>
              </li>
            ))}
          </ol>

          <div className="process-wrap">
            <Photo name="mentorLab" className="process-photo" sizes="(max-width: 860px) 100vw, 40vw" />
            <div>
              <h3 className="h3 process-title" data-reveal>How we work</h3>
              <ol className="process">
                {PROCESS.map((p, i) => (
                  <li key={p.title} data-reveal style={{ '--d': i }}>
                    <b>{p.title}</b>
                    <span>{p.body}</span>
                  </li>
                ))}
              </ol>
              <div className="btn-row" data-reveal>
                <PillLink to="/contact">Start a project</PillLink>
              </div>
            </div>
          </div>
        </div>
      </section>

      <GetInvolved title="Not sure which track fits?" photo="smilingClassroom" />
    </main>
  );
}

export default Services;
